export default __webpack_public_path__ + "static/media/ars-maquette-medium-webfont.1b7d39ab.woff";